const COUNTRY_CURRENCY_MAP: Record<string, string> = {
  IN: "INR",
  US: "USD",
  GB: "GBP",
  CA: "CAD",
  AU: "AUD",
  AE: "AED",
  AF: "AFN",
  AL: "ALL",
  DZ: "DZD",
  AR: "ARS",
  AM: "AMD",
  BD: "BDT",
  BH: "BHD",
  BR: "BRL",
  CN: "CNY",
  EG: "EGP",
  FR: "EUR",
  DE: "EUR",
  IT: "EUR",
  ES: "EUR",
  PT: "EUR",
  GR: "EUR",
  NL: "EUR",
  BE: "EUR",
  AT: "EUR",
  IE: "EUR",
  HK: "HKD",
  ID: "IDR",
  IL: "ILS",
  JP: "JPY",
  JO: "JOD",
  KW: "KWD",
  MY: "MYR",
  MX: "MXN",
  NZ: "NZD",
  NO: "NOK",
  OM: "OMR",
  PK: "PKR",
  PH: "PHP",
  PL: "PLN",
  QA: "QAR",
  RU: "RUB",
  SA: "SAR",
  SG: "SGD",
  ZA: "ZAR",
  KR: "KRW",
  LK: "LKR",
  SE: "SEK",
  CH: "CHF",
  TW: "TWD",
  TH: "THB",
  TR: "TRY",
  VN: "VND",
};

export const getCountryCurrencyCode = (
  countryCode: string,
): string | undefined => COUNTRY_CURRENCY_MAP[countryCode.toUpperCase()];

export const getCurrencyIdForCountry = (
  countryCode: string,
  currencies: { currency_code: string; currency_id: string }[],
): string | undefined => {
  const currencyCode = getCountryCurrencyCode(countryCode);
  if (!currencyCode) return undefined;
  return currencies.find((c) => c.currency_code === currencyCode)?.currency_id;
};
